/* HIT posts API ENDPOINT */

import Api from '@/services/Api'

export default {
  getCategories () {
    return Api().get('menu/categories')
  },
  getCategoryItems (category) {
    return Api().get('menu/categories/' + category)
  },
  getCategory (category) {
    return Api().get('menu/edit/category/' + category)
  },
  deleteCategory (category) {
    return Api().delete('menu/edit/categories/:category', { data: category })
  },
  addCategory (category) {
    return Api().post('menu/edit/categories/:category', category)
  },
  updateCategory (category) {
    return Api().put('menu/edit/categories/:category', category)
  },
  getEditCategoryItems (category) {
    return Api().get('menu/edit/categories/' + category)
  }
}



// WEBPACK FOOTER //
// ./src/services/CategoriesService.js